import { createContext, useContext } from "react";

interface NewLookContextValue {
  isNewLook: boolean;
  setIsNewLook: (isNewLook: boolean) => void;
}

export const NewLookContext = createContext<NewLookContextValue>({
  isNewLook: false,
  setIsNewLook: () => {},
});

export const useNewLook = () => useContext(NewLookContext);
